
























































import {
  ref,
  defineComponent,
  computed,
  useContext, useFetch, onMounted, useRoute,
} from '@nuxtjs/composition-api';
import {useCart} from '~/modules/checkout/composables/useCart';
import {useWishlist} from '~/modules/wishlist/composables/useWishlist';
import {useUser} from '~/modules/customer/composables/useUser';

import RegisterOnlineAccount from '~/components/Palmers/Forms/RegisterOnlineAccount.vue';
import RegisterJoinClub from '~/components/Palmers/Forms/RegisterJoinClub.vue';
import RegisterOnlineClub from '~/components/Palmers/Forms/RegisterOnlineClub.vue';
import {RegisterFormFields, FormName, RegisterFormFieldsClub} from "~/components/Palmers/Forms/Register/types";
import {mergeItem} from "~/helpers/asyncLocalStorage";
import {useUrl} from "~/composables/Palmers";
import getRegistrationClubFormFieldsOptions from "~/customQueries/queries/getRegistrationClubFormFieldsOptions.gql";
import {getMetaInfoVuePages} from "~/helpers/getMetaInfo";
import LoaderFrame from "~/components/Palmers/BaseComponents/Loaders/LoaderFrame.vue";
import {getItem, removeItem} from "~/helpers/asyncLocalStorage";
import createCustomerSF from "~/customQueries/mutation/createCustomerSF.gql";

export default defineComponent({
  name: 'Register',
  components: {
    RegisterOnlineAccount,
    RegisterJoinClub,
    RegisterOnlineClub,
    LoaderFrame
  },
  props: {
    isCheckout: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  middleware: 'is-authenticated',
  setup(props) {
    const {app, $vsf} = useContext();
    const {getPageUrl} = useUrl();

    const {
      register,
      loading,
      error: userError,
    } = useUser();

    const {load: loadCart} = useCart();
    const {loadItemsCount} = useWishlist();

    const loaded = ref(false);
    const registerSelectors = ref({})

    const selectedAccount = ref<string>('default');
    const currentlyDisplayedForm = ref<FormName>('register');
    const barTitle = computed(() => {
      const mapFormNameToTopBarLabel: Record<FormName, string> = {
        register: 'Register',
      };

      return mapFormNameToTopBarLabel[currentlyDisplayedForm.value];
    });

    onMounted(async () => {
      const route = useRoute();
      const allowedAccountCodes = [
        'default',
        'club',
        'both'
      ];

      let accountCodeFromUrl :string = route?.value?.query?.mode as string;

      if(!(allowedAccountCodes.indexOf(accountCodeFromUrl) > -1)){
        accountCodeFromUrl = null;
      }
      const defaultAccountCode = accountCodeFromUrl ? accountCodeFromUrl : 'default';

      const account = await getItem('selectedAccount');
      const selected = account?.['id'];
      await removeItem('selectedAccount');

      selectedAccount.value = ((selected && Object.keys(selected).length !== 0) ? selected : defaultAccountCode).toString();
    });

    const registerForm = ref<RegisterFormFields>({
      prefix: '',
      email: '',
      firstName: '',
      lastName: '',
      password: '',
      passwordConfirm: '',
      sf_nl_zustimmung: false,
      privacyPolicy: false,
      sf_agb: false,
      sf_datenschutz: false,
      sf_is_online_customer: false,
      sf_registration_type: '',
      gender: null,
    });

    const registerFormClub = ref<RegisterFormFieldsClub>({
      email: '',
      firstName: '',
      lastName: '',
      password: '',
      passwordConfirm: '',
      shouldSubscribeToNewsletter: false,
      privacyPolicy: false,
      sf_agb: false,
      sf_datenschutz: false,
      sf_is_online_customer: false,
      sf_registration_type: '',
      gender: null,
      prefix: null,
      suffix: '',
      title_prefix: '',
      title_suffix: '',
      date_of_birth: '',
      sf_company: '',
      sf_street: '',
      sf_door: '',
      sf_house: '',
      sf_postcode: '',
      sf_city: '',
      sf_country_id: '',
      sf_telephone: '',
      sf_geworben_von: '',
      sf_mobiltelefon: '',
      sf_nl_zustimmung: false,
      sf_promotions: false,
      sf_anruf: false,
      sf_sms: false,
      sf_requestedcardtype: '',
      advertised_by: '',
      sf_bh_cup: '',
      sf_hoeschen_groesse: '',
      sf_konfektionsgroesse: '',
      sf_schuhgroesse: '',
      sf_unterbrustweite: '',
    });


    // @ts-expect-error Recaptcha is not registered as a Nuxt module. Its absence is handled in the code
    const {$recaptcha, $config} = useContext();
    const isRecaptchaEnabled = ref<boolean>(typeof $recaptcha !== 'undefined' && Boolean($config.isRecaptcha));

    const getRecaptchaInfo = async (isRecaptchaOn: boolean): Promise<{ token: string | null, cleanup: () => void }> => {
      if (isRecaptchaOn) {
        $recaptcha.init();
        return {
          token: await $recaptcha.getResponse(), cleanup: () => {
            $recaptcha.reset();
          }
        };
      }
      return {
        token: null, cleanup: () => {
        }
      };
    };

    let sf_is_online_customer_val: boolean = false;
    if (selectedAccount.value === 'default' || selectedAccount.value === 'both') {
      sf_is_online_customer_val = true;
    }

    const onRegisterFormSubmit = async (form: RegisterFormFields) => {
      registerForm.value = form;
      const {token, cleanup} = await getRecaptchaInfo(isRecaptchaEnabled.value);
      await register({
        user: {
          prefix: form.prefix,
          email: form.email,
          firstname: form.firstName,
          lastname: form.lastName,
          password: form.password,
          sf_nl_zustimmung: form.sf_nl_zustimmung,
          privacy_policy: form.sf_datenschutz,
          ...(token ? {recaptchaToken: token} : {}),
          sf_agb: form.sf_agb,
          sf_datenschutz: form.sf_datenschutz,
          sf_is_online_customer:  sf_is_online_customer_val,
          sf_registration_type: selectedAccount.value,
          sf_requestedcardtype: "null",
        },
      });
      cleanup();
      if (!userError.value.register) {
        await Promise.all([loadItemsCount(), loadCart()]);

        if (props.isCheckout) {
          await mergeItem('checkout', {register: {form: form}});
          await app.router.push(getPageUrl({name: 'shipping'}))
        } else {
          await app.router.push(getPageUrl({name: 'login', query: {register: true}}))
        }
      }
    };

    const onRegisterFormSubmitClub = async (form: RegisterFormFieldsClub) => {
      registerFormClub.value = form;
      const {token, cleanup} = await getRecaptchaInfo(isRecaptchaEnabled.value);
      await register({
        user: {
          email: form.email,
          firstname: form.firstName,
          lastname: form.lastName,
          password: form.password,
          is_subscribed: form.shouldSubscribeToNewsletter,
          privacy_policy: form.privacyPolicy,
          ...(token ? {recaptchaToken: token} : {}),
          sf_agb: form.sf_agb,
          sf_datenschutz: form.sf_datenschutz,
          sf_is_online_customer:  sf_is_online_customer_val,
          sf_registration_type: selectedAccount.value,
          gender: form.gender,
          title_prefix: form.title_prefix,
          title_suffix: form.title_suffix,
          prefix: form.prefix,
          suffix: form.suffix,
          date_of_birth: form.date_of_birth,
          sf_company: form.sf_company,
          sf_street: form.sf_street,
          sf_door: form.sf_door,
          sf_house: form.sf_house,
          sf_geworben_von: form.sf_geworben_von,
          sf_postcode: form.sf_postcode,
          sf_city: form.sf_city,
          sf_country_id: form.sf_country_id,
          sf_telephone: form.sf_telephone,
          sf_mobiltelefon: form.sf_mobiltelefon,
          sf_nl_zustimmung: form.sf_nl_zustimmung,
          sf_promotions: form.sf_promotions,
          sf_anruf: form.sf_anruf,
          sf_sms: form.sf_sms,
          advertised_by: form.advertised_by,
          sf_bh_cup: form.sf_bh_cup,
          sf_requestedcardtype: form.sf_requestedcardtype,
          sf_hoeschen_groesse: form.sf_hoeschen_groesse,
          sf_konfektionsgroesse: form.sf_konfektionsgroesse,
          sf_schuhgroesse: form.sf_schuhgroesse,
          sf_unterbrustweite: form.sf_unterbrustweite,
        },
      });

      cleanup();
      if (!userError.value.register) {
        await Promise.all([loadItemsCount(), loadCart()]);

        if (props.isCheckout) {
          await mergeItem('checkout', {register: {form: form}});
          await app.router.push(getPageUrl({name: 'shipping'}))
        } else {
          await app.router.push(getPageUrl({name: 'login', query: {register: true}}))
        }
      }
    };


    const query = getRegistrationClubFormFieldsOptions;

    const fetchData = async () => {
      //@ts-ignore
      const {getRegistrationClubFormFieldsOptions} = (await $vsf.$magento.api.customQuery({
        query: query,
      })).data;

      registerSelectors.value = getRegistrationClubFormFieldsOptions || {};

      loaded.value = true;
    };

    useFetch(fetchData);

    return {
      userError,
      loading,
      barTitle,
      registerForm,
      registerFormClub,
      isRecaptchaEnabled,
      selectedAccount,
      registerSelectors,
      onRegisterFormSubmit,
      onRegisterFormSubmitClub,
      meta: getMetaInfoVuePages({
        title: 'Register'
      })
    };
  },
  head() {
    return this.meta;
  }
});
